const REGISTRATION_PLATE_REGEX = new RegExp(TYROOLA.globals.registrationPlateValidation);
/**
 * Simple Registration Plate Validator
 * @constructor
 */
class RegistrationPlateValidator {
    /**
     * @param {String}registrationPlate
     * @returns {Boolean}
     */
    isValid(registrationPlate) {
        return RegistrationPlateValidator.validate(registrationPlate);
    }
    
    static validate(registrationPlate) {
        return REGISTRATION_PLATE_REGEX.test(registrationPlate);
    }
}

export { RegistrationPlateValidator };
export default RegistrationPlateValidator;
